import { CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import logo from 'assets/images/ELCOS_logo_color_woSrl_v1.svg'
import pxToRem from "assets/theme/functions/pxToRem";
import PageLayout from "components/LayoutContainers/PageLayout";

export default function LoadingPage () {
  return (
    <PageLayout background="#EAEAEA">
      <MDBox sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50\%, -50\%)"
      }} display="flex" flexDirection="column" alignItems="center">
        <MDBox mb={2} component="img" src={logo} width={pxToRem(150)}></MDBox>
        <CircularProgress />
      </MDBox>
    </PageLayout>
  )
}